import React from 'react'

const OCR_Filter = () => {
  return (
    <div>
      filter
    </div>
  )
}

export default OCR_Filter
